/* ==========================================================================
   Delivery Date Picker — blocked dates based on Tag / Collection / Metafield
   + Delivery Region (Karachi vs other cities adds extra block days)
   + "karachi-shipping-only" tag: hides the other-cities option entirely
   Gifts360 — Horizon theme
   Fixed: calendar uses viewport-aware fixed positioning so it never gets
   clipped by the cart drawer's overflow, on any screen size/device.
   ========================================================================== */
(function () {
  var WIDGET_ID = 'gs-delivery-date-wrap';
  var REGION_ID = 'gs-delivery-region';
  var CITY_NOTE_ID = 'gs-city-note';
  var INPUT_ID = 'gs-delivery-date-input';
  var MSG_ID = 'gs-delivery-date-msg';
  var STYLE_ID = 'gs-delivery-date-style';

  var BRAND_COLOR = '#1b4332'; // change to match your checkout button color
  var VIEWPORT_MARGIN = 12;    // min gap kept between calendar and screen edges
  var GAP_FROM_INPUT = 8;      // gap between input and calendar

  var TAG_RULES = [
    { match: '24-hour', blockDays: 0 },
    { match: '48-hour', blockDays: 1 },
    { match: '72-hour', blockDays: 2 },
    { match: '5-day',   blockDays: 4 },
    { match: '5 day',   blockDays: 4 },
    { match: '21 Days',   blockDays: 20 },
    { match: '14 Days',   blockDays: 13 },
    { match: '7 days',   blockDays: 6 },
    { match: '6 days',   blockDays: 5 }
  ];

  // A product carrying this tag can ONLY be delivered within Karachi —
  // when present in the cart, the "other cities" option is hidden entirely.
  var KARACHI_ONLY_TAG = 'karachi-shipping-only';

  // Extra days added on top of the product's own block days, based on region
  var REGION_OPTIONS = [
    { value: 'karachi', label: 'Karachi', extraDays: 0 },
    { value: 'other',   label: 'Sindh, Peshawar, Punjab, Quetta', extraDays: 4 }
  ];

  var metaCache = {};
  var cartAttrs = { date: null, region: null };
  var submitGuardAttached = false;
  var repositionListenersAttached = false;
  var fpInstance = null;
  var lastCartSignature = null;
  var baseBlockDays = 0;      // block days from product tags/collections/metafield only
  var karachiOnlyActive = false; // true when any cart item carries KARACHI_ONLY_TAG
  var widgetBuildInProgress = false; // prevents duplicate widgets from overlapping async builds

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = document.createElement('style');
    css.id = STYLE_ID;
    css.textContent =
      '#' + WIDGET_ID + '{padding:14px 0;border-top:1px solid #e5e5e5;margin-bottom:10px;}' +
      '#' + WIDGET_ID + ' label{display:block;font-size:13px;font-weight:600;margin-bottom:7px;color:#1a1a1a;}' +
      '#' + WIDGET_ID + ' label .req{color:#d32f2f;}' +
      '#' + WIDGET_ID + ' .gs-field{margin-bottom:12px;}' +
      '#' + CITY_NOTE_ID + '{font-size:12px;color:#8a6d3b;margin-top:6px;}' +
      /* font-size is 16px (not 14px) on purpose: iOS Safari auto-zooms the
         whole page when a focused input/select has font-size under 16px,
         which is what was causing the horizontal scrollbar on iPhone the
         moment the calendar opened. Kept visually the same size via
         slightly reduced padding. */
      '.gs-select{width:100%;padding:9px 12px;border:1px solid #d6d6d6;border-radius:6px;' +
        'font-size:16px;background:#fff;cursor:pointer;}' +
      '.gs-select:focus{outline:none;border-color:' + BRAND_COLOR + ';box-shadow:0 0 0 3px ' + BRAND_COLOR + '22;}' +
      '.gs-select:disabled{background-color:#f5f5f5;cursor:not-allowed;opacity:.75;}' +
      '.gs-date-input{width:100%;padding:9px 12px;border:1px solid #d6d6d6;border-radius:6px;' +
        'font-size:16px;cursor:pointer;background:#fff url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="%23666" stroke-width="1.5"><path d="M3 6h10M5 2v2M11 2v2M3.5 3h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/></svg>\') no-repeat right 12px center;' +
        'background-size:16px;transition:border-color .15s ease;-webkit-text-size-adjust:100%;}' +
      '.gs-date-input:focus{outline:none;border-color:' + BRAND_COLOR + ';box-shadow:0 0 0 3px ' + BRAND_COLOR + '22;}' +
      '.gs-date-input:disabled{background-color:#f5f5f5;cursor:not-allowed;opacity:.6;}' +
      '#' + MSG_ID + '{font-size:12px;margin-top:6px;min-height:14px;}' +
      '.flatpickr-calendar{border-radius:10px;box-shadow:0 8px 24px rgba(0,0,0,.2);border:1px solid #eee;font-family:inherit;background:#fff;}' +
      '.flatpickr-months{padding:10px 0 4px;}' +
      '.flatpickr-current-month{font-size:14px;font-weight:600;}' +
      '.flatpickr-weekday{font-weight:600;color:#888;font-size:11px;text-transform:uppercase;}' +
      '.flatpickr-day{border-radius:6px;font-size:13px;}' +
      '.flatpickr-day.selected,.flatpickr-day.selected:hover{background:' + BRAND_COLOR + ';border-color:' + BRAND_COLOR + ';color:#fff;}' +
      '.flatpickr-day.today{border-color:' + BRAND_COLOR + ';}' +
      '.flatpickr-day:hover{background:' + BRAND_COLOR + '1a;}' +
      '.flatpickr-day.flatpickr-disabled{color:#ccc;text-decoration:line-through;}' +
      '.flatpickr-months .flatpickr-prev-month:hover svg,.flatpickr-months .flatpickr-next-month:hover svg{fill:' + BRAND_COLOR + ';}' +
      /* Cross-device positioning fixes — calendar is positioned with fixed
         top/left computed in JS (positionCalendar), so it always sits inside
         the visible viewport and is never clipped by the cart drawer's own
         overflow/scroll container. */
      '.flatpickr-calendar{' +
        'position:fixed !important;' +
        'z-index:2147483647 !important;' +
        'max-width:calc(100vw - ' + (VIEWPORT_MARGIN * 2) + 'px) !important;' +
        'width:307px;' +
        'box-sizing:border-box;' +
        'visibility:hidden;' + /* becomes visible only after JS positions it */
      '}' +
      '.flatpickr-calendar.gs-positioned{visibility:visible !important;}' +
      '.flatpickr-calendar.open{max-height:none;}' +
      '@media (max-width:420px){' +
        '.flatpickr-calendar{width:calc(100vw - ' + (VIEWPORT_MARGIN * 2) + 'px) !important;}' +
        '.flatpickr-day{height:38px;line-height:38px;}' +
        '.flatpickr-innerContainer,.flatpickr-rContainer{width:100%;}' +
        '.dayContainer{width:100% !important;min-width:100% !important;max-width:100% !important;}' +
      '}';
    document.head.appendChild(css);
  }

  function fetchProductMeta(handle) {
    if (metaCache[handle]) return Promise.resolve(metaCache[handle]);
    return fetch('/products/' + handle + '?view=delivery-meta')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var meta = {
          tags: (data.tags || []).map(function (t) { return t.toLowerCase(); }),
          collections: (data.collections || []).map(function (c) { return c.toLowerCase(); }),
          delivery_date_min: data.delivery_date_min || null
        };
        metaCache[handle] = meta;
        return meta;
      })
      .catch(function () { return { tags: [], collections: [], delivery_date_min: null }; });
  }

  function parseDeliveryValue(str) {
    if (!str) return null;
    var m = String(str).match(/(\d+(\.\d+)?)\s*(hour|hr|day)/i);
    if (!m) return null;
    var num = parseFloat(m[1]);
    var unit = m[3].toLowerCase();
    if (unit.indexOf('day') === 0) return Math.max(0, Math.round(num) - 1);
    return Math.max(0, Math.ceil(num / 24) - 1);
  }

  function matchRules(list) {
    var max = 0;
    list.forEach(function (val) {
      TAG_RULES.forEach(function (rule) {
        if (val.indexOf(rule.match) !== -1 && rule.blockDays > max) max = rule.blockDays;
      });
    });
    return max;
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // Computes both the block-days and the karachi-only restriction in one
  // pass over the cart's products.
  function getCartConstraints(cart) {
    var handles = cart.items.map(function (i) { return i.handle; });
    var uniqueHandles = handles.filter(function (h, i) { return handles.indexOf(h) === i; });
    return Promise.all(uniqueHandles.map(fetchProductMeta)).then(function (metas) {
      var overallMax = 0;
      var karachiOnly = false;
      metas.forEach(function (meta) {
        var fromTags = matchRules(meta.tags);
        var fromCollections = matchRules(meta.collections);
        var fromMetafield = parseDeliveryValue(meta.delivery_date_min) || 0;
        var itemMax = Math.max(fromTags, fromCollections, fromMetafield);
        if (itemMax > overallMax) overallMax = itemMax;
        if (meta.tags.indexOf(KARACHI_ONLY_TAG) !== -1) karachiOnly = true;
      });
      return { blockDays: overallMax, karachiOnly: karachiOnly };
    });
  }

  function getRegionExtraDays(regionValue) {
    var found = REGION_OPTIONS.filter(function (r) { return r.value === regionValue; })[0];
    return found ? found.extraDays : 0;
  }

  function computeMinDate() {
    var extra = getRegionExtraDays(cartAttrs.region);
    var d = new Date();
    d.setDate(d.getDate() + 1 + baseBlockDays + extra);
    return d;
  }

  function cartSignature(cart) {
    return cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
  }

  function persistAttributes() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Delivery Date': cartAttrs.date || '',
          'Delivery Region': cartAttrs.region
            ? (REGION_OPTIONS.filter(function (r) { return r.value === cartAttrs.region; })[0] || {}).label || ''
            : ''
        }
      })
    });
  }

  function setCheckoutState(enabled) {
    var btn = document.getElementById('checkout');
    if (!btn) return;
    btn.disabled = !enabled;
    btn.style.opacity = enabled ? '1' : '0.5';
    btn.style.cursor = enabled ? 'pointer' : 'not-allowed';
  }

  function isComplete() {
    return !!(cartAttrs.date && cartAttrs.region);
  }

  // Builds the <option> list, skipping non-Karachi cities when the cart
  // contains a karachi-shipping-only product.
  function buildRegionOptionsHtml(karachiOnly) {
    var html = '<option value="" disabled selected>Select your city</option>';
    REGION_OPTIONS.forEach(function (r) {
      if (karachiOnly && r.value !== 'karachi') return;
      html += '<option value="' + r.value + '">' + r.label + '</option>';
    });
    return html;
  }

  function buildWidget(karachiOnly) {
    var wrap = document.createElement('div');
    wrap.id = WIDGET_ID;

    wrap.innerHTML =
      '<div class="gs-field">' +
        '<label for="' + REGION_ID + '">Select delivery city <span class="req">*</span></label>' +
        '<select id="' + REGION_ID + '" class="gs-select">' + buildRegionOptionsHtml(karachiOnly) + '</select>' +
        (karachiOnly ? '<div id="' + CITY_NOTE_ID + '">This order contains an item that can only be delivered within Karachi.</div>' : '') +
      '</div>' +
      '<div class="gs-field">' +
        '<label for="' + INPUT_ID + '">Select a delivery date <span class="req">*</span></label>' +
        '<input type="text" id="' + INPUT_ID + '" class="gs-date-input" placeholder="Select city first" readonly>' +
      '</div>' +
      '<div id="' + MSG_ID + '"></div>';
    return wrap;
  }

  // Rebuilds just the <select> options in place (used when the cart changes
  // and the karachi-only restriction turns on/off), keeping the current
  // selection if it's still valid.
  function refreshRegionOptions(karachiOnly) {
    var select = document.getElementById(REGION_ID);
    if (!select) return;
    var currentValue = select.value;
    select.innerHTML = buildRegionOptionsHtml(karachiOnly);

    var stillValid = !karachiOnly || currentValue === 'karachi';
    if (currentValue && stillValid) {
      select.value = currentValue;
    } else if (karachiOnly) {
      // Previously-selected "other cities" is no longer allowed — force Karachi.
      select.value = 'karachi';
      applyRegionSelection('karachi', true);
    }

    var noteEl = document.getElementById(CITY_NOTE_ID);
    var field = select.closest('.gs-field');
    if (karachiOnly && !noteEl && field) {
      var note = document.createElement('div');
      note.id = CITY_NOTE_ID;
      note.textContent = 'This order contains an item that can only be delivered within Karachi.';
      field.appendChild(note);
    } else if (!karachiOnly && noteEl) {
      noteEl.remove();
    }
  }

  /* ------------------------------------------------------------------ *
   * Viewport-aware positioning
   * The calendar element is positioned with `position:fixed`, so it is
   * never clipped by any scrollable/overflow-hidden ancestor (the cart
   * drawer's inner wrapper included). We compute top/left ourselves from
   * the input's real screen position, flip above the input when there
   * isn't room below, and clamp horizontally so it always stays fully
   * on-screen — on phones, tablets, and desktop alike.
   * ------------------------------------------------------------------ */
  function positionCalendar() {
    if (!fpInstance || !fpInstance.isOpen) return;
    var cal = fpInstance.calendarContainer;
    var anchor = fpInstance.altInput || fpInstance.input;
    if (!cal || !anchor) return;

    cal.style.maxHeight = '';
    cal.style.overflowY = '';

    var rect = anchor.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;
    var calWidth = cal.offsetWidth;
    var calHeight = cal.offsetHeight;

    var left = rect.left;
    if (left + calWidth > vw - VIEWPORT_MARGIN) left = vw - VIEWPORT_MARGIN - calWidth;
    if (left < VIEWPORT_MARGIN) left = VIEWPORT_MARGIN;

    var spaceBelow = vh - rect.bottom - VIEWPORT_MARGIN;
    var spaceAbove = rect.top - VIEWPORT_MARGIN;
    var top;

    if (calHeight <= spaceBelow) {
      top = rect.bottom + GAP_FROM_INPUT;
    } else if (calHeight <= spaceAbove) {
      top = rect.top - calHeight - GAP_FROM_INPUT;
    } else if (spaceAbove > spaceBelow) {
      top = VIEWPORT_MARGIN;
      cal.style.maxHeight = spaceAbove + 'px';
      cal.style.overflowY = 'auto';
    } else {
      top = rect.bottom + GAP_FROM_INPUT;
      cal.style.maxHeight = Math.max(spaceBelow, 150) + 'px';
      cal.style.overflowY = 'auto';
    }

    cal.style.top = top + 'px';
    cal.style.left = left + 'px';
    cal.style.right = 'auto';
    cal.classList.add('gs-positioned');
  }

  function schedulePositioning() {
    requestAnimationFrame(function () {
      requestAnimationFrame(positionCalendar);
    });
  }

  function attachRepositionListeners() {
    if (repositionListenersAttached) return;
    repositionListenersAttached = true;
    document.addEventListener('scroll', function () {
      if (fpInstance && fpInstance.isOpen) positionCalendar();
    }, true);
    window.addEventListener('resize', function () {
      if (fpInstance && fpInstance.isOpen) positionCalendar();
    });
  }

  function getAppendTarget(input) {
    var dialog = input.closest ? input.closest('dialog') : null;
    return dialog || document.body;
  }

  function initFlatpickrOnce(input) {
    fpInstance = flatpickr(input, {
      minDate: computeMinDate(),
      dateFormat: 'Y-m-d',
      altInput: true,
      altInputClass: 'gs-date-input',
      altFormat: 'D, d M Y',
      disableMobile: true,
      appendTo: getAppendTarget(input),
      onOpen: function () {
        schedulePositioning();
      },
      onChange: function (selectedDates, dateStr) {
        if (!dateStr) return;
        var msgEl = document.getElementById(MSG_ID);
        msgEl.textContent = 'Saving...';
        msgEl.style.color = '#767676';
        setCheckoutState(false);
        cartAttrs.date = dateStr;
        persistAttributes().then(function () {
          msgEl.textContent = 'Delivery date saved: ' + dateStr;
          msgEl.style.color = '#2e7d32';
          setCheckoutState(isComplete());
        });
      },
      onMonthChange: schedulePositioning,
      onYearChange: schedulePositioning
    });
    attachRepositionListeners();
    if (fpInstance.altInput) {
      fpInstance.altInput.disabled = true;
      fpInstance.altInput.placeholder = 'Select city first';
    }
  }

  // Shared by manual dropdown changes AND the automatic karachi-only
  // preselect. `silent` skips the "please select a date" nudge message,
  // used only for the automatic case triggered from a cart-change refresh.
  function applyRegionSelection(value, silent) {
    var msgEl = document.getElementById(MSG_ID);
    cartAttrs.region = value;
    cartAttrs.date = null; // city changed -> old date may now be invalid, force reselect

    if (fpInstance) {
      fpInstance.clear();
      fpInstance.set('minDate', computeMinDate());
      if (fpInstance.altInput) {
        fpInstance.altInput.disabled = false;
        fpInstance.altInput.placeholder = 'Choose date';
      }
    }

    if (msgEl) {
      msgEl.textContent = silent ? 'City changed — please pick a delivery date again.' : 'Please select a delivery date.';
      msgEl.style.color = '#767676';
    }
    setCheckoutState(false);
    persistAttributes();
  }

  function onRegionChange(e) {
    applyRegionSelection(e.target.value, false);
  }

  function attachSubmitGuard() {
    if (submitGuardAttached) return;
    submitGuardAttached = true;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.id === 'cart-form' && !isComplete()) {
        e.preventDefault();
        e.stopPropagation();
        var msgEl = document.getElementById(MSG_ID);
        if (msgEl) {
          msgEl.textContent = !cartAttrs.region
            ? 'Please select your delivery city first.'
            : 'Please select a delivery date before checkout.';
          msgEl.style.color = '#d32f2f';
        }
      }
    }, true);
  }

  function ensureWidget() {
    var checkoutBtn = document.getElementById('checkout');
    if (!checkoutBtn) return false;

    if (document.getElementById(WIDGET_ID)) {
      setCheckoutState(isComplete());
      return true;
    }

    // Building the widget is async (cart + product-tag fetches). The 400ms
    // poll can fire several more times before that finishes, and without
    // this lock each of those ticks would see "no widget yet" and start
    // its own build — producing duplicates. Set the lock synchronously,
    // before any await, so every tick in between is a no-op.
    if (widgetBuildInProgress) return false;
    widgetBuildInProgress = true;

    injectStyles();

    getCart().then(function (cart) {
      lastCartSignature = cartSignature(cart);
      return getCartConstraints(cart).then(function (constraints) {
        baseBlockDays = constraints.blockDays;
        karachiOnlyActive = constraints.karachiOnly;

        // Re-check in case a build somehow slipped through concurrently.
        if (document.getElementById(WIDGET_ID)) return;

        var widget = buildWidget(karachiOnlyActive);
        checkoutBtn.parentElement.insertBefore(widget, checkoutBtn);
        document.getElementById(REGION_ID).addEventListener('change', onRegionChange);

        initFlatpickrOnce(document.getElementById(INPUT_ID));

        // Only one valid city — pick it automatically so the user doesn't
        // have to interact with a single-option dropdown.
        if (karachiOnlyActive) {
          var select = document.getElementById(REGION_ID);
          select.value = 'karachi';
          applyRegionSelection('karachi', true);
        }
      });
    }).catch(function () {
      // ignore — the next poll tick will simply retry
    }).then(function () {
      widgetBuildInProgress = false;
    });

    attachSubmitGuard();
    return true;
  }

  function checkForCartChanges() {
    if (!document.getElementById(WIDGET_ID) || !fpInstance || fpInstance.isOpen) return;
    getCart().then(function (cart) {
      var sig = cartSignature(cart);
      if (sig === lastCartSignature) return;
      lastCartSignature = sig;
      getCartConstraints(cart).then(function (constraints) {
        baseBlockDays = constraints.blockDays;
        var restrictionChanged = constraints.karachiOnly !== karachiOnlyActive;
        karachiOnlyActive = constraints.karachiOnly;

        if (restrictionChanged) {
          refreshRegionOptions(karachiOnlyActive);
        }
        fpInstance.set('minDate', computeMinDate());
      });
    });
  }

  // Works on both the cart drawer (dialog present in DOM even when closed —
  // harmless to inject early) and the standalone /cart page (#checkout always visible).
  setInterval(function () {
    if (document.getElementById('checkout')) ensureWidget();
  }, 400);

  setInterval(checkForCartChanges, 2500);
})();


/* ==========================================================================
   Greeting Card Picker — visual card grid (single-select) with pagination
   Cart / cart-drawer — Gifts360 — Horizon theme
   - Saves the chosen card as a CART ATTRIBUTE ("Greeting Card")
   - Adds a paid "Greeting Card" product line (Rs.200) to the cart so the
     charge shows at checkout and in the Shopify admin order.
   - Clicking the selected card again deselects it and removes the charge.
   OPTIONAL field — does not block checkout.

   All cart calls use XMLHttpRequest instead of fetch(): Horizon patches
   window.fetch to broadcast a "cart updated" event on /cart/*.js calls,
   which re-renders (and can close) the drawer. XHR isn't intercepted.
   ========================================================================== */
(function () {
  /* ---------------------- SETTINGS (edit these) ---------------------- */
  // Variant ID of the "Greeting Card" product (Rs.200). Leave 0 until you
  // create the product — with 0, only the attribute is saved (no charge).
  var CARD_VARIANT_ID = 50809692618822;
  var CARD_PRICE_LABEL = 'Rs.200';
  /* ------------------------------------------------------------------- */

  var WIDGET_ID = 'gs-greeting-card-wrap';
  var GRID_ID = 'gs-gc-grid';
  var PREV_ID = 'gs-gc-prev';
  var NEXT_ID = 'gs-gc-next';
  var PAGE_INFO_ID = 'gs-gc-page-info';
  var MSG_ID = 'gs-greeting-card-msg';
  var STYLE_ID = 'gs-greeting-card-style';
  var DATE_WIDGET_ID = 'gs-delivery-date-wrap';

  var BRAND_COLOR = '#1b4332';
  var CART_ATTR_KEY = 'Greeting Card';
  var PAGE_SIZE = 8;

  var CARD_OPTIONS = [
    { label: 'Happy Birthday', icon: '\uD83C\uDF82' },
    { label: 'Happy Anniversary', icon: '\uD83D\uDC8D' },
    { label: 'Congratulations', icon: '\uD83C\uDF89' },
    { label: 'Get Well Soon', icon: '\uD83E\uDD12' },
    { label: 'Thank You', icon: '\uD83D\uDE4F' },
    { label: "Happy Valentine's Day", icon: '\uD83D\uDC98' },
    { label: 'Merry Christmas', icon: '\uD83C\uDF84' },
    { label: 'Happy New Year', icon: '\uD83C\uDF86' },
    { label: "Happy Father's Day", icon: '\uD83D\uDC54' },
    { label: "Happy Mother's Day", icon: '\uD83C\uDF37' },
    { label: 'Ramadan Mubarak', icon: '\uD83C\uDF19' },
    { label: 'Umrah Mubarak', icon: '\uD83D\uDD4C' },
    { label: 'Hajj Mubarak', icon: '\uD83D\uDD4B' },
    { label: 'Eid Mubarak', icon: '\uD83C\uDF8A' }
  ];

  var selectedCard = '';
  var currentPage = 0;
  var pendingOps = 0;               // number of cart operations in flight
  var opChain = Promise.resolve();  // serialises cart operations
  var widgetBuildInProgress = false;

  function chargeEnabled() { return Number(CARD_VARIANT_ID) > 0; }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = document.createElement('style');
    css.id = STYLE_ID;
    css.textContent =
      '#' + WIDGET_ID + '{padding:14px 0;border-top:1px solid #e5e5e5;margin-bottom:10px;}' +
      '#' + WIDGET_ID + ' .gs-gc-title{font-size:14px;font-weight:700;color:#1a1a1a;margin:0 0 2px;}' +
      '#' + WIDGET_ID + ' .gs-gc-sub{font-size:12px;color:#767676;margin:0 0 12px;}' +
      '#' + WIDGET_ID + ' .gs-gc-price{font-weight:700;color:' + BRAND_COLOR + ';}' +
      '.' + GRID_ID + '{display:grid;grid-template-columns:repeat(auto-fill,minmax(88px,1fr));' +
        'gap:8px;margin-bottom:10px;}' +
      '.gs-gc-card{display:flex;flex-direction:column;align-items:center;justify-content:center;' +
        'gap:6px;padding:12px 4px;min-height:82px;border:1.5px solid #d6d6d6;border-radius:10px;' +
        'background:#fff;cursor:pointer;font-size:11.5px;font-weight:600;color:#1a1a1a;' +
        'text-align:center;line-height:1.25;transition:border-color .15s ease,background .15s ease,box-shadow .15s ease;' +
        '-webkit-tap-highlight-color:transparent;}' +
      '.gs-gc-card .gs-gc-icon{font-size:24px;line-height:1;}' +
      '.gs-gc-card:hover{border-color:' + BRAND_COLOR + ';}' +
      '.gs-gc-card:focus-visible{outline:2px solid ' + BRAND_COLOR + ';outline-offset:2px;}' +
      '.gs-gc-card.selected{border-color:' + BRAND_COLOR + ';background:' + BRAND_COLOR + '14;' +
        'box-shadow:0 0 0 1.5px ' + BRAND_COLOR + ';}' +
      '.gs-gc-pagination{display:flex;align-items:center;justify-content:space-between;gap:8px;}' +
      '.gs-gc-pagination button{background:#fff;border:1px solid #d6d6d6;border-radius:6px;' +
        'padding:7px 14px;font-size:13px;font-weight:600;color:#1a1a1a;cursor:pointer;}' +
      '.gs-gc-pagination button:disabled{opacity:.4;cursor:not-allowed;}' +
      '#' + PAGE_INFO_ID + '{font-size:12px;color:#767676;}' +
      '#' + MSG_ID + '{font-size:12px;margin-top:8px;min-height:14px;}';
    document.head.appendChild(css);
  }

  function buildWidget() {
    var wrap = document.createElement('div');
    wrap.id = WIDGET_ID;
    var sub = chargeEnabled()
      ? 'Add a greeting card for <span class="gs-gc-price">' + CARD_PRICE_LABEL + '</span> (optional). Tap again to remove.'
      : 'Select a card to add to your order (optional)';
    wrap.innerHTML =
      '<p class="gs-gc-title">Choose Greeting Card</p>' +
      '<p class="gs-gc-sub">' + sub + '</p>' +
      '<div class="' + GRID_ID + '" id="' + GRID_ID + '" role="radiogroup" aria-label="Greeting card"></div>' +
      '<div class="gs-gc-pagination">' +
        '<button type="button" id="' + PREV_ID + '">\u2039 Prev</button>' +
        '<span id="' + PAGE_INFO_ID + '"></span>' +
        '<button type="button" id="' + NEXT_ID + '">Next \u203A</button>' +
      '</div>' +
      '<div id="' + MSG_ID + '"></div>';
    return wrap;
  }

  function renderPage() {
    var grid = document.getElementById(GRID_ID);
    if (!grid) return;
    grid.innerHTML = '';

    var start = currentPage * PAGE_SIZE;
    var pageItems = CARD_OPTIONS.slice(start, start + PAGE_SIZE);

    pageItems.forEach(function (opt) {
      var isSelected = selectedCard === opt.label;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gs-gc-card' + (isSelected ? ' selected' : '');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      btn.innerHTML =
        '<span class="gs-gc-icon">' + opt.icon + '</span>' +
        '<span class="gs-gc-label">' + opt.label + '</span>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        selectCard(opt.label);
      });
      grid.appendChild(btn);
    });

    var prevBtn = document.getElementById(PREV_ID);
    var nextBtn = document.getElementById(NEXT_ID);
    var infoEl = document.getElementById(PAGE_INFO_ID);
    var total = CARD_OPTIONS.length;
    var shown = pageItems.length;

    if (infoEl) infoEl.textContent = (start + 1) + '\u2013' + (start + shown) + ' of ' + total;
    if (prevBtn) prevBtn.disabled = currentPage === 0;
    if (nextBtn) nextBtn.disabled = (start + shown) >= total;
  }

  /* ------------------------- cart helpers (XHR) ------------------------- */
  function xhrJSON(method, url, bodyObj) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { resolve(JSON.parse(xhr.responseText)); } catch (err) { resolve(null); }
        } else {
          // Shopify returns e.g. {"status":422,"description":"..."} — keep the
          // reason so it can be shown to the user / found in the console.
          var detail = '';
          try {
            var j = JSON.parse(xhr.responseText);
            detail = j.description || j.message || '';
          } catch (e) {}
          var err = new Error(method + ' ' + url + ' failed: ' + xhr.status + ' ' + detail);
          err.status = xhr.status;
          err.detail = detail;
          reject(err);
        }
      };
      xhr.onerror = function () { reject(new Error('Network error')); };
      xhr.send(bodyObj ? JSON.stringify(bodyObj) : null);
    });
  }

  function findCardLine(cart) {
    if (!cart || !cart.items || !chargeEnabled()) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === Number(CARD_VARIANT_ID)) return cart.items[i];
    }
    return null;
  }

  // Keeps the visible "Estimated total" in step with the cart, because the
  // XHR calls above deliberately don't trigger the theme's drawer re-render.
  function updateTotals(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    var v = cart.total_price / 100;
    var s = (v % 1 === 0)
      ? v.toLocaleString('en-US')
      : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var text = 'Rs.' + s + ' PKR';
    var nodes = document.querySelectorAll('[data-cart-subtotal]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = text;
      nodes[i].setAttribute('value', text);
    }
  }

  // Makes the cart's greeting-card LINE match `label` ('' = no card).
  function syncCardLine(label) {
    if (!chargeEnabled()) return xhrJSON('GET', '/cart.js');
    return xhrJSON('GET', '/cart.js').then(function (cart) {
      var line = findCardLine(cart);
      if (!label) {
        return line ? xhrJSON('POST', '/cart/change.js', { id: line.key, quantity: 0 }) : cart;
      }
      var addLine = function () {
        return xhrJSON('POST', '/cart/add.js', {
          items: [{ id: Number(CARD_VARIANT_ID), quantity: 1, properties: { 'Card': label } }]
        }).then(function () { return xhrJSON('GET', '/cart.js'); });
      };
      if (line) {
        // Already the right card with qty 1 -> nothing to do.
        if (line.quantity === 1 && line.properties && line.properties['Card'] === label) return cart;
        // Switching cards: change.js does not reliably update line properties,
        // so remove the old line and add a fresh one carrying the new card name.
        return xhrJSON('POST', '/cart/change.js', { id: line.key, quantity: 0 }).then(addLine);
      }
      return addLine();
    });
  }

  function setMsg(text, color) {
    var msgEl = document.getElementById(MSG_ID);
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.style.color = color || '#767676';
  }

  function enqueue(task) {
    pendingOps += 1;
    opChain = opChain.then(task).catch(function () {}).then(function () { pendingOps -= 1; });
    return opChain;
  }

  function selectCard(value) {
    var previous = selectedCard;
    var next = (selectedCard === value) ? '' : value; // click again = deselect
    selectedCard = next;
    renderPage();
    setMsg('Saving...', '#767676');

    enqueue(function () {
      return syncCardLine(next)
        .then(function (cart) {
          updateTotals(cart);
          var attrs = {};
          attrs[CART_ATTR_KEY] = next;
          return xhrJSON('POST', '/cart/update.js', { attributes: attrs });
        })
        .then(function () {
          if (next) {
            setMsg('Greeting card added: ' + next + (chargeEnabled() ? ' (+' + CARD_PRICE_LABEL + ')' : ''), '#2e7d32');
          } else {
            setMsg('Greeting card removed.', '#767676');
          }
        })
        .catch(function (err) {
          // Roll the UI back if the cart couldn't be updated (e.g. variant unavailable)
          if (window.console) console.error('[Greeting Card]', err);
          selectedCard = previous;
          renderPage();
          setMsg('Could not update greeting card' +
            (err && err.detail ? ': ' + err.detail : ', please try again.'), '#d32f2f');
        });
    });
  }

  function goPrev(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (currentPage === 0) return;
    currentPage -= 1;
    renderPage();
  }

  function goNext(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if ((currentPage + 1) * PAGE_SIZE >= CARD_OPTIONS.length) return;
    currentPage += 1;
    renderPage();
  }

  // Reads the cart and makes the widget (and cart) consistent:
  //  - card line exists + attribute set  -> show it selected (force qty 1)
  //  - attribute set but line was removed -> treat as deselected
  //  - line exists but no attribute       -> orphan, remove it
  //  - card line is the ONLY item left    -> remove it (nothing to deliver)
  function reconcile() {
    if (pendingOps > 0) return Promise.resolve();
    return xhrJSON('GET', '/cart.js').then(function (cart) {
      if (pendingOps > 0) return;
      var existingAttr = (cart.attributes && cart.attributes[CART_ATTR_KEY]) || '';
      var line = findCardLine(cart);
      var changedUI = false;

      if (!chargeEnabled()) {
        if (existingAttr !== selectedCard) { selectedCard = existingAttr; changedUI = true; }
      } else {
        var onlyCardLeft = line && cart.items.length === 1;
        if (onlyCardLeft || (line && !existingAttr)) {
          return enqueue(function () {
            return xhrJSON('POST', '/cart/change.js', { id: line.key, quantity: 0 })
              .then(function (c) {
                updateTotals(c);
                var a = {}; a[CART_ATTR_KEY] = '';
                return xhrJSON('POST', '/cart/update.js', { attributes: a });
              })
              .then(function () { selectedCard = ''; renderPage(); });
          });
        }
        if (existingAttr && !line) {
          selectedCard = '';
          changedUI = true;
          var a2 = {}; a2[CART_ATTR_KEY] = '';
          xhrJSON('POST', '/cart/update.js', { attributes: a2 }).catch(function () {});
        } else if (existingAttr && line) {
          if (selectedCard !== existingAttr) { selectedCard = existingAttr; changedUI = true; }
          if (line.quantity !== 1) {
            xhrJSON('POST', '/cart/change.js', { id: line.key, quantity: 1 })
              .then(updateTotals).catch(function () {});
          }
        }
      }

      if (selectedCard) {
        var idx = CARD_OPTIONS.findIndex(function (o) { return o.label === selectedCard; });
        if (idx >= 0 && changedUI) currentPage = Math.floor(idx / PAGE_SIZE);
      }
      if (changedUI) renderPage();
    }).catch(function () {});
  }

  function ensureWidget() {
    var checkoutBtn = document.getElementById('checkout');
    if (!checkoutBtn) return false;
    if (document.getElementById(WIDGET_ID)) return true;
    if (widgetBuildInProgress) return false;
    widgetBuildInProgress = true;

    injectStyles();
    var widget = buildWidget();

    var dateWidget = document.getElementById(DATE_WIDGET_ID);
    if (dateWidget && dateWidget.parentElement) {
      dateWidget.parentElement.insertBefore(widget, dateWidget);
    } else {
      checkoutBtn.parentElement.insertBefore(widget, checkoutBtn);
    }

    document.getElementById(PREV_ID).addEventListener('click', goPrev);
    document.getElementById(NEXT_ID).addEventListener('click', goNext);

    renderPage();
    reconcile();
    widgetBuildInProgress = false;
    return true;
  }

  setInterval(function () {
    if (document.getElementById('checkout')) ensureWidget();
  }, 400);

  // Slow consistency check (e.g. customer removed the card line in the cart list)
  setInterval(function () {
    if (document.getElementById(WIDGET_ID)) reconcile();
  }, 3000);
})();